import { render } from "./ReadOnlyDataModal.vue?vue&type=template&id=0b75f30a&scoped=true&ts=true"
import script from "./ReadOnlyDataModal.vue?vue&type=script&lang=ts"
export * from "./ReadOnlyDataModal.vue?vue&type=script&lang=ts"

import "./ReadOnlyDataModal.vue?vue&type=style&index=0&id=0b75f30a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b75f30a"]])

export default __exports__